import React from "react";
import SkeletonImage from "./common/SkeletonImage";

const UseCasesGrid = ({ useCases }) => {
  if (!useCases || useCases.length === 0) {
    return null;
  }

  const grid = Array.isArray(useCases) ? useCases[0] : useCases;

  const getImageUrl = (icon) => {
    if (!icon) return null;
    const imageUrl = icon.formats?.thumbnail?.url || icon.url;
    return imageUrl.startsWith("/")
      ? `${process.env.REACT_APP_STRAPI_URL}${imageUrl}`
      : imageUrl;
  };

  return (
    <section className="py-16 bg-gradient-to-b from-green-50 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {grid.title}
          </h2>
          {grid.description && (
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              {grid.description}
            </p>
          )}
          {grid.note && (
            <p className="text-md text-gray-500 max-w-3xl mx-auto mt-2">
              {grid.note}
            </p>
          )}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {(grid.useCases || []).map((useCase) => {
            const imageUrl = getImageUrl(useCase.icon);
            return (
              <div
                key={useCase.id}
                className="bg-white rounded-xl border border-gray-200 shadow-sm hover:shadow-lg transition-all duration-300 p-5 flex flex-col items-start"
              >
                <div className="w-10 h-10 rounded-lg bg-green-600 flex items-center justify-center mb-3 overflow-hidden">
                  {imageUrl ? (
                    <SkeletonImage
                      src={imageUrl}
                      alt={useCase.title}
                      className="w-full h-full"
                      imgClassName="w-full h-full object-contain p-1.5 brightness-0 invert"
                      icon={false}
                    />
                  ) : (
                    <span className="w-6 h-6 rounded-full bg-white/30" />
                  )}
                </div>
                <h3 className="text-base font-bold text-gray-900 mb-1.5">
                  {useCase.title}
                </h3>
                <p className="text-sm text-gray-600 leading-snug">
                  {useCase.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default UseCasesGrid;